module.exports = __webpack_public_path__ + "img/image0.29829205.png";